import styled from 'styled-components'
import { defaultTheme } from 'styles/theme/default'

export const TeamSelectContainer = styled.div`
    position: absolute;
    opacity: 0;
    width: 273px;
    height: 312px;
    left: 0;
    z-index: 200;

    cursor: default;
    
    /* Cinza/Branco-100 */
    background: #FFFFFF;
    border-radius: 8px;
    filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.12));
    
    ::before {
        visibility: visible;
        content: "";
        position: absolute;
        left: 25%;
        bottom: 100%;
        border-width: 0px 10px 10px 10px;
        border-style: solid;
        border-color: transparent transparent #FFFFFF transparent;
        transform: translateX(-50%);
    }

    &.below {
        opacity: 1;
        top: 175%;
    }

    &.above {
        opacity: 1;
        top: -332px;
    
        ::before {
            left: 25%;
            top: 100%;
            border-width: 10px 10px 0px 10px;
            border-color: #FFF transparent transparent transparent;
            transform: translateX(-50%);
        }
    }    

    
    .header {
        padding: 16px;
        width: 100%;
    }

    .input {
        position: relative;
        height: 40px;
        width: 100%;
    }

    .inputBox {
        width: 100%;
        border-radius: 37px;
        height: 40px;
    }
    
    .input input{
        padding-left: 15%;
        color: black;
        border: none;
        font-size: 0.9rem;
        background-color: ${defaultTheme.colors['base-input']};
        ::placeholder {
            color: ${defaultTheme.colors['gray-200']};
        }
    }

    .input img {
        position: absolute;
        z-index: 1;
        left: 12px;
        top: 0;
        bottom: 0;
        margin-top: auto;
        margin-bottom: auto;
        cursor: default;
        pointer-events: none;
    }

    .list {
        width: 100%;
        height: 70%;

        display: flex;
        flex-direction: column;

        overflow-y: auto;
    }

    .entry {
        align-items: center;

        height: 40px;

        :hover {
            background-color: ${defaultTheme.colors['base-light']};
        }
    }


    .entryName {
        display: flex;
        font-size: 0.9rem;
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        text-align: left;
        background: none;
        border: none;
        width: 100%;
        height: 100%;
        padding: 12px 25px;
        color: black;

        justify-content: space-between;
    }

    .entryTeam {
        width: 55%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .entryInfo {
        color: ${defaultTheme.colors['gray-200']}
    }
    
    @media screen and (max-width:769px){
        left: 0;
        right: 0;
        top: 0;
        bottom: 10%;
        margin: auto;
        .header {
            margin-bottom: 0;
            margin-top: 0;
        }
    
        ::before {
            visibility: hidden;
        }
    }

`

export const SelectBack = styled.div`
    cursor: default;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 190;
`